export default {
  data: () => ({
    syncronizedQueryParameters: [],
  }),

  mounted() {
    console.log('updating', this.syncronizedQueryParameters)
    for (const p of this.syncronizedQueryParameters) {
      this.updateComponentValueFromQueryParam(
        p.componentKey,
        p.queryKey,
        p.forceArray
      )
      this.$watch(p.componentKey, this.updateQueryParameters)
    }
    this.$store.dispatch('files/queryFiles')
  },

  methods: {
    updateComponentValueFromQueryParam(
      componentKey,
      queryKey,
      forceArray = false
    ) {
      let queryParams = JSON.parse(JSON.stringify(this.$route.query))
      let queryValue = queryParams.hasOwnProperty(queryKey)
        ? queryParams[queryKey]
        : null
      if (!!this[componentKey] && queryValue) {
        if (forceArray)
          queryValue = Array.isArray(queryValue) ? queryValue : [queryValue]
        this[componentKey] = queryValue
      }
    },
    updateQueryParameters() {
      const query = this.syncronizedQueryParameters.reduce((acc, param) => {
        if (this[param.componentKey].length > 0) {
          acc[param.queryKey] = this[param.componentKey]
        }
        return acc
      }, {})
      this.$router.replace({ path: '', query })
    },
  },
}
